import { ADVICE_NAMES, Advice } from "Store/advice/interfaces";

import { Paragraph } from "App/global-style";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { TextLanguage } from "Store/texts/interfaces";
import React from "react";
import { StyledAdviceH3 } from "../../adviceStyled";
import { AdviceIntroMessage } from "../AdviceMessages/AdviceIntro/AdviceIntroMessage";
import { useAdviceResult } from "../hooks/stateSelectors";
import { getAdvicesAllowed } from "../utils";

interface Props {
  sortedInsurance: {
    name: ADVICE_NAMES;
    title: string;
  }[];
  formText: any;
  lang: TextLanguage;
}

export const AdviceIntro = ({
  sortedInsurance,
  formText,
  lang,
}: Props): React.ReactElement => {
  const isAdvisor = useIsAdvisorSelector();
  const adviceResult = useAdviceResult() as Advice;
  const listOfAllowedAdvices = getAdvicesAllowed(adviceResult);
  const advicesNotAllowed = listOfAllowedAdvices.length === 0;

  return (
    <>
      <StyledAdviceH3>
        {formText.advice.description.subHeader[lang]}
      </StyledAdviceH3>
      <Paragraph className="AdviceIntroText">
        {formText.advice.description.desc1[lang]}
      </Paragraph>
      {!isAdvisor && listOfAllowedAdvices.length < 3 && (
        <Paragraph className="AdviceIntroText">
          {formText.advice.description.contactUs[lang]}
        </Paragraph>
      )}
      <AdviceIntroMessage
        insurances={sortedInsurance}
        adviceTexts={formText.advice}
        lang={lang}
      />
      {!advicesNotAllowed && (
        <StyledAdviceH3>
          {formText.advice.description.desc2[lang]}
        </StyledAdviceH3>
      )}
    </>
  );
};
